import React from 'react'

export default class Tag extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  componentDidMount() {

  }
  render() {
    return (
      <span className={`badge badge-pill badge-primary ${this.props.className}`}>{this.props.name}</span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/contents/Tag.js